import { StyleSheet } from 'react-native';
import { Colors } from 'react-native-paper';
import { appColors } from '../../../assets/styles/global';
import { pixelDimensions } from '../../../config/utils';

const styles = StyleSheet.create({
  buttonBack: {
    paddingVertical: pixelDimensions(2),
    paddingHorizontal: pixelDimensions(6),
    marginHorizontal: pixelDimensions(4),
    marginVertical: pixelDimensions(2),
  },
  content: {
    padding: pixelDimensions(2),
  },
  iconPerson: {
    fontSize: pixelDimensions(4),
    color: Colors.blue200,
  },
  iconPlay: {
    position: 'absolute',
    zIndex: 10,
    fontSize: pixelDimensions(30),
    color: appColors.primary,
  },
  iconPersonFull: {
    color: Colors.purple900,
  },
  imageLogo: {
    position: 'absolute',
    height: pixelDimensions(20),
    width: pixelDimensions(20) * (75 / 22),
  },
  imageCoin: {
    height: pixelDimensions(8),
    width: pixelDimensions(8) * (58 / 53),
  },
  input: {
    marginBottom: pixelDimensions(5),
    marginHorizontal: pixelDimensions(5),
  },
  textBack: {
    color: Colors.white,
    fontSize: pixelDimensions(4.5),
    textAlign: 'center',
  },
  textEnter: {
    paddingTop: pixelDimensions(30),
  },
  textNoResults: {
    textAlign: 'center',
    fontSize: pixelDimensions(6),
    fontFamily: 'MBold',
    marginVertical: pixelDimensions(50),
    marginHorizontal: pixelDimensions(4),
  },
  textTitle: {
    fontSize: pixelDimensions(5),
    textAlign: 'center',
    marginBottom: pixelDimensions(5),
  },
  textSubTitle: {
    fontSize: pixelDimensions(5),
    textAlign: 'center',
    marginVertical: pixelDimensions(7),
    marginHorizontal: pixelDimensions(5),
  },
  textList: {
    color: Colors.white,
    fontSize: pixelDimensions(3.5),
  },
  textPurple: {
    color: appColors.primary,
  },
  textVale: {
    fontSize: pixelDimensions(4),
    textAlign: 'center',
    color: Colors.black,
  },
  textCoin: {
    fontSize: pixelDimensions(4),
    textAlign: 'center',
  },
  viewBase: {
    flex: 1,
    backgroundColor: Colors.grey300,
  },
  viewCoinContainer: {
    paddingHorizontal: pixelDimensions(3),
    justifyContent: 'center',
  },
  viewFlexCenter: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
  viewInterval: {
    padding: pixelDimensions(2),
    borderRadius: pixelDimensions(20),
    backgroundColor: Colors.purple900,
  },
  viewListItem: {
    marginHorizontal: pixelDimensions(5),
    marginBottom: pixelDimensions(4),
  },
  viewListItemTop: {
    marginBottom: pixelDimensions(2),
    padding: pixelDimensions(3),
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: appColors.primary,
    borderRadius: pixelDimensions(3),
  },
  viewProgress: {
    backgroundColor: Colors.white,
    width: pixelDimensions(70),
  },
  viewRowBetween: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  viewStars: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: pixelDimensions(5),
  },
  viewVideoContainer: {
    padding: pixelDimensions(5),
  },
  viewVideoFrame: {
    height: pixelDimensions(50),
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: pixelDimensions(5),
    borderColor: Colors.grey500,
    borderWidth: 5,
    backgroundColor: Colors.purple100,
  },
  viewVideoFrameAnd: {
    borderWidth: 0,
  },
  viewWhiteCircle: {
    backgroundColor: Colors.white,
    height: pixelDimensions(7),
    width: pixelDimensions(7),
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 50,
    marginRight: pixelDimensions(2),
  },

  videoAnd: {
    borderWidth: 0,
  },
});

export default styles;
